import * as React from 'react';
import styled from 'styled-components';
import { animated, useSpring } from '@react-spring/web';
import { useModal } from '../../../hooks/useModal';
import { ButtonClose } from '../../ui/ButtonClose';

export const ModalContent: React.FC = React.memo(() => {
  const { show, content, hideCloseButton, closeModal, initialAnimation, delay } =
    useModal();
  const animatedProps = useSpring({
    immediate: !initialAnimation,
    delay: delay ? delay : 0,
    from: { opacity: 0, transform: 'translate3d(0, -1em, 0)' },
    to: {
      opacity: show ? 1 : 0,
      transform: show ? 'translate3d(0, 0em, 0)' : 'translate3d(0, -1em, 0)'
    }
  });
  return (
    <StyledModalContent style={animatedProps}>
      {content}
      {!hideCloseButton ? (
        <ButtonClose className="close-button-modal" onClick={() => closeModal()} />
      ) : null}
    </StyledModalContent>
  );
});

export const StyledModalContent = styled(animated.div)`
  position: fixed;
  width: 100%;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: 9999;
  color: var(--modal-color, var(--body-color, #000));

  .close-button-modal {
    position: absolute;
    top: 2em;
    right: 2em;
    padding: 0;
    z-index: 1;
  }
`;
